const hasWindowHistory = typeof window === 'object' && window.history;

export const replaceUrl = (url) => {
    if (hasWindowHistory) {
        window.history.replaceState({}, document.title, url);
    }
};
